import React from 'react'
import { Alert, Button, Form, Input } from 'antd'
import { createSelector } from '@reduxjs/toolkit'
import { useTranslation } from 'react-i18next'

import { CustomModal } from '../../common/CustomModal'
import { useAppDispatch, useAppSelector } from '../../../core/hooks'
import { CardinalApiState, provideParentAuthKey, cancelParentKeyInit, resetParentKeyInitState } from '../../../core/services/auth.api'
import { revertAll } from '../../../core/app'
import './index.css'

const reduxSelector = createSelector(
  (state: { cardinalApi: CardinalApiState }) => state.cardinalApi,
  (cardinalApi: CardinalApiState) => ({
    parentCredentialsRequest: cardinalApi.parentCredentialsRequest,
    parentKeyInitError: cardinalApi.parentKeyInitError,
  }),
)

interface ParentAuthFormType {
  authKey: string
}

export const ModalParentAuth = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const { parentCredentialsRequest, parentKeyInitError } = useAppSelector(reduxSelector)

  const isVisible = !!parentCredentialsRequest

  const handleSubmit = (values: ParentAuthFormType) => {
    dispatch(provideParentAuthKey({ authKey: values.authKey }))
  }

  const handleCancel = () => {
    dispatch(cancelParentKeyInit())
    dispatch(resetParentKeyInitState())
    dispatch(revertAll())
  }

  const getCustomFooter = () => [
    <Button key="cancel" onClick={handleCancel}>
      {t('buttons.cancel')}
    </Button>,
    <Button key="submit" type="primary" onClick={() => form.submit()}>
      {t('buttons.submit')}
    </Button>,
  ]

  return (
    <CustomModal isVisible={isVisible} title={t('auth.parentKeyInit.modalTitle')} customFooter={getCustomFooter()} closable={false}>
      <div className="modalParentAuth">
        <Alert
          type="info"
          description={
            <div className="modalParentAuth__content">
              <p>{t('auth.parentKeyInit.alert', { parentName: parentCredentialsRequest?.parentHcpName ?? '' })}</p>
            </div>
          }
        />
        {parentKeyInitError && <Alert type="error" message={t(parentKeyInitError)} style={{ marginTop: 12 }} />}
        <Form className="modalParentAuth__form" layout="vertical" colon={false} form={form} onFinish={handleSubmit}>
          <Form.Item name="authKey" label={t('auth.parentKeyInit.authKeyLabel')} rules={[{ required: true, message: t('auth.parentKeyInit.authKeyRequired') }]}>
            <Input.Password placeholder={t('auth.parentKeyInit.authKeyLabel')} size="large" />
          </Form.Item>
        </Form>
      </div>
    </CustomModal>
  )
}
